import map from 'lodash/map';

import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import { TBaseSubscription } from '~/src/features/tariffBuilder/reducer/initialState';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';

type TExpectedEntity = Exclude<EEntity, EEntity.speed | EEntity.tv | EEntity.routers | EEntity.decoders | EEntity.services | EEntity.entertainments>
type TReturnType = (TBaseSubscription & { isSelected: boolean, key: number })[];

const getEntities = (entity: TExpectedEntity) => (state: TInitialState): TReturnType => {
    const entities = state[entity];

    return map(
        entities,
        (oneOf, key) => ({
            ...oneOf,
            isSelected: oneOf.quantity > 0,

            key: Number(key),
        }),
    );
};

export default getEntities;
